import { render, staticRenderFns } from "./investment.vue?vue&type=template&id=0d61eef1"
import script from "./investment.vue?vue&type=script&lang=js"
export * from "./investment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports